export enum Tiers {
  SILVER = 'Silver',
  GOLD = 'Gold',
  PLATINUM = 'Platinum',
  DIAMOND = 'Diamond',
  DIAMOND_BLACK = 'Black Diamond',
}
